const navigatePath = {
  "JOB-01": "/SCRC060007",
  "JOB-02": "/SCRC050009",
  "JOB-03": "/SCRC050012",
  "JOB-04": "/SCRC050016",
  "JOB-05": "/SCRC040002",
  "JOB-06": "/SCRC040002",
  "JOB-07": "/SCRC040004",
  "JOB-08": "/SCRC040004",
  "JOB-09": "",
  "JOB-10": "/SCRC060112",
  "JOB-11": "/SCRC080006",
  "JOB-12": "/SCRC080009",
  "JOB-13": "",
  "JOB-14": "/SCRC070105",
  "JOB-15": "/SCRC070104",
  "JOB-16": "/SCRC050028",
  "JOB-17": "/SCRC050017",
  "JOB-18": "/SCRC050024",
  "JOB-19": "/SCRC050017",
  "JOB-20": "/SCRC050029",
  "JOB-21": "/SCRC050018",
  "JOB-22": "/SCRC050019",
  "JOB-23": "/SCRC060110",
  "JOB-24": "/SCRC060112",
  "JOB-25": "/SCRC060112",
  "JOB-26": "/SCRC060116",
  "JOB-27": "/SCRC060103",
  "JOB-28": "/SCRC060013",
  "JOB-29": "/SCRC060013",
  "JOB-30": "/SCRC060110",
  "JOB-31": "/SCRC060026",
  "JOB-32": "/SCRC060026",
  "JOB-33": "/SCRC060028",
  "JOB-34": "/SCRC060132",
  "JOB-35": "/SCRR410016",
  "JOB-36": "/SCRR410017",
  "JOB-37": "",
  "JOB-38": "",
  "JOB-39": "/SCRR410028",
  "JOB-40": "/SCRR410022",
  "JOB-41": "/SCRR410027",
  "JOB-42": "",
  "JOB-43": "",
  "JOB-44": "/SCRC070206",
  "JOB-45": "",
  "JOB-46": "",
  "JOB-47": "/SCRC060134",
  "JOB-48": "",
  "JOB-49": "",
  "JOB-50": "",
  "JOB-51": "",
  "JOB-52": "",
  "JOB-53": "",
  "JOB-54": "",
  "JOB-55": "",
  "JOB-56": "",
  "JOB-57": "",
  "JOB-58": "",
  "JOB-59": "",
  "JOB-60": "",
  "JOB-61": "",
  "JOB-62": "",
  "JOB-63": "",
  "JOB-64": "",
  "JOB-65": "",
  "JOB-66": "",
  "JOB-67": "",
  "JOB-68": "",
  "JOB-69": "",
  "JOB-70": "",
  "JOB-71": "",
  "JOB-72": "",
  "JOB-73": "/SCRC030001",
  "JOB-74": "",
  "JOB-75": "/SCRC070105",
  "JOB-76": "/SCRC010004",
  "JOB-77": "/SCRR410016",
  "JOB-78": "",
  "JOB-79": "/SCRC080007",
  "JOB-80": "",
} as { [key: string]: string };

export { navigatePath };
